import { Divider, Popover, Space, Spin, Typography, theme } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { SuspendedRosterStatusPopupConductItem } from "components/Shared/SuspendedRosterStatusPopup/SuspendedRosterStatusPopupConductItem.tsx";
import { useFetchPersonConducts } from "hooks/useConductApi.ts";
import { useState } from "react";
import { useIntl } from "react-intl";

const { useToken } = theme;

type Props = {
  fixtureRosterPlayer: any;
};

export const SuspendedRosterStatusPopup = ({ fixtureRosterPlayer }: Props) => {
  const { token } = useToken();
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);

  const { data: conductsResponse, isFetching } = useFetchPersonConducts({
    personId: fixtureRosterPlayer?.dcPersonId,
    status: "ACTIVE",
    enabled: open && !!fixtureRosterPlayer?.dcPersonId,
  });
  const conducts: any[] = conductsResponse?.data ?? [];

  const content = (
    <div style={{ maxWidth: 480, width: "max-content", maxHeight: 500, overflowY: "auto" }}>
      {isFetching ? (
        <Spin size="small" />
      ) : conducts.length === 0 ? (
        <Typography.Text>{formatMessage({ id: "rosterStatus.noActiveConducts" }).toUpperCase()}</Typography.Text>
      ) : (
        <Space direction="vertical" size={0} style={{ width: "100%" }}>
          {conducts.map((conduct, index) => (
            <div key={conduct?.id ?? index}>
              {index > 0 && <Divider style={{ margin: "8px 0" }} />}
              <SuspendedRosterStatusPopupConductItem conduct={conduct} />
            </div>
          ))}
        </Space>
      )}
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="top" open={open} onOpenChange={setOpen}>
      <DefaultButton
        type="text"
        icon={<i className="fa fa-info-circle fa-lg" style={{ color: token.blue }} />}
        onClick={(e) => e.stopPropagation()}
      />
    </Popover>
  );
};
